var toMoney = (function () {

  var moneyFormat = theme.moneyFormat;

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return formatMoney;
})();

document.addEventListener("product:added", function (event) {
  var passepartout = false;
  var frame = false;

  if (event.detail.ignore) {
    return;
  }

  if (ProductPage && ProductPage.passepartout && ProductPage.passepartout.id) {
    passepartout = ProductPage.passepartout;
  }

  if (ProductPage && ProductPage.frame && ProductPage.frame.id) {
    frame = ProductPage.frame;
  }

  if (frame || passepartout) {
    var quantity = parseInt($(".ProductForm .QuantitySelector__CurrentQuantity").val());
    var bundle_id = Math.ceil(Math.random() * 100000);

    console.log("event.detail", event.detail);
    fetch("/cart/change.js", {
      body: JSON.stringify({
        id: event.detail.key,
        quantity: quantity,
        properties: {
          _bundle_id: bundle_id,
        },
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (cart) {
      var itemsToAdd = [];

      if (frame.id) {
        itemsToAdd.push({
          id: frame.id,
          quantity: quantity,
          properties: {
            _bundle_id: bundle_id,
          },
        });
      }

      if (passepartout) {
        itemsToAdd.push({
          id: passepartout.id,
          quantity: quantity,
          properties: {
            _bundle_id: bundle_id,
          },
        });
      }

      fetch("/cart/add.js", {
        body: JSON.stringify({ items: itemsToAdd }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then(function (response) {
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: false,
            detail: {
              variant: frame ? frame.id : passepartout.id,
              quantity: quantity,
              is_frame: true,
              ignore: true,
            },
          })
        );
      });
    });
  }
});

/*
var print_passpartout_mappings = [
  {
    "print": "13 x 18 cm",
    "passepartout": "A5"
  },{
    "print": "A5",
    "passepartout": "A4"
  },  {
    "print": "A4",
    "passepartout": "A3"
  },  {
    "print": "A4",
    "passepartout": "30 x 40 cm"
  },  {
    "print": "A3",
    "passepartout": "A2"
  }, {
    "print": "A2",
    "passepartout": "A1"
  }, {
    "print": "30 x 30 cm",
    "passepartout": "40 x 40 cm"
  }, {
    "print": "40 x 40 cm",
    "passepartout": "50 x 50 cm"
  },  {
    "print": "60 x 60 cm",
    "passepartout": "70 x 70 cm"
  },  {
    "print": "70 x 70 cm",
    "passepartout": "100 x 100 cm"
  }, {
    "print": "30 x 40 cm",
    "passepartout": "40 x 50 cm"
  },  {
    "print": "40 x 50 cm",
    "passepartout": "50 x 70 cm"
  }, {
    "print": "60 x 60 cm",
    "passepartout": "70 x 70 cm"
  }, {
    "print": "50 x 70 cm",
    "passepartout": "70 x 100 cm"
  },  {
    "print": "60 x 80 cm",
    "passepartout": "70 x 100 cm"
  }, {
    "print": "70 x 100 cm",
    "passepartout": "100 x 140 cm"
  },  {
    "print": "70 x 70 cm",
    "passepartout": "100 x 100 cm"
  }, {
    "print": "100 x 140 cm",
    "passepartout": "120 x 160 cm"
  }
];
*/

var findAndParseJSONTag = function (selector) {
  if (!selector) {
    return;
  }

  var targ = document.querySelector(selector);

  if (!selector) {
    return;
  }

  return JSON.parse(targ.innerText);
};

var print_passpartout_mappings = findAndParseJSONTag("[data-passepartout-mappings]");

var SearchMappings = function (from) {
  var allowedFroms = ["passepartout", "print"];

  if (allowedFroms.indexOf(from) === -1) {
    return;
  }

  var search = function (query) {
    var results = print_passpartout_mappings.filter(function (item) {
      if (item[from] === query) {
        return true;
      }
    });

    return results;
  };

  return search;
};

var searchByPrintsize = new SearchMappings("print");
var searchByPassepartoutSize = new SearchMappings("passepartout");

/*  Determine passepartout size from
print size */

var findPassepartoutSizeFromPrintsize = function (print_size) {
  var results = searchByPrintsize(print_size);

  if (results.length === 0) {
    return false;
  }

  return results[0].passepartout;
};

/* Determine print "format" based on
print-size */

var findPrintoutSizeFromPassepartout = function (passepartout_size) {
  var results = searchByPassepartoutSize(passepartout_size);

  if (results.size === 0) {
    return false;
  }

  return results[0].print;
};

/* Determine validity of adding passepartout from
print-size */

var printHasPassepartout = function (print_size) {
  var result = findPassepartoutSizeFromPrintsize(print_size);
  return !!result;
};

/* Determine frame-size from
passepartout size */
var getFrameSizeByPassepartoutSize = function (passepartout_size) {
  return findPrintoutSizeFromPassepartout(passepartout_size);
};

var passePartoutJson = findAndParseJSONTag("[data-passepartout-json]");
var framesJson = findAndParseJSONTag("[data-frames-json]");

var passePartoutProducts = passePartoutJson.passepartout;
var frameJsonProducts = framesJson.frames;

/* Querying a specific passepartout from
print size
passepartout color */

var getPassepartoutProductFrom = function (print_size, passepartout_color) {
  if (!printHasPassepartout(print_size)) {
    return;
  }

  var passepartout_size = findPassepartoutSizeFromPrintsize(print_size);

  return passePartoutProducts.find(function (item) {
    if (item.size === passepartout_size) {
      return true;
    }
  });
};

var findPassepartoutProductById = function (product_id) {
  return passePartoutProducts.find(function (product) {
    if (product.id == product_id) {
      return product;
    }
  });
};

var findFrameProductById = function (product_id) {
  return frameJsonProducts.find(function (product) {
    if (product.id == product_id) {
      return product;
    }
  });
};

var convertedPassepartoutName = function (name) {
  return name.split(" (")[0];
};

// Get list of all passepartouts available in specific converted size
var findAllMatchingPassepartoutVariants = function (poster_variant) {
  var printVariant = poster_variant;
  var printSize = printVariant.option1;

  var passepartoutSize = findPassepartoutSizeFromPrintsize(printSize);

  var matchedPassepartoutProductList = passePartoutProducts
    .map(function (product) {
      var match = product.variants.find(function (variant) {
        // convert example: 40 x 50 cm (Window: 30x40) => 40 x 50 cm
        var convertedPassepartoutName = variant.option1.split(" (")[0];

        if (convertedPassepartoutName == passepartoutSize) {
          return true;
        }
      });

      return match;
    })
    .filter(function (match_item) {
      if (match_item) {
        return true;
      }
    });

  return matchedPassepartoutProductList;
};

ProductPage.pricing = (function () {
  var total = function () {
    var prices = [ProductPage.poster.price || 0, ProductPage.passepartout.price || 0, ProductPage.frame.price || 0];

    return prices.reduce(function (a, b) {
      return a + b;
    });
  };

  var totalMoney = function () {
    return toMoney(total());
  };

  return {
    total,
    totalMoney,
  };
})();

ProductPage.form_items = function (selector) {
  this.form = document.querySelector(selector);
  this.formData = new FormData(this.form);
  this.qty = this.formData.get("qty");

  this.bundle_id = Math.ceil(Math.random() * 100000000);

  this.lineItem = function (item, name) {
    if (!item.id) {
      return;
    }

    var lineitem = {
      id: item.id,
    };

    lineitem.name = name ? name : null;

    lineitem.properties = {};
    lineitem.properties._bundle_id = this.bundle_id;
    lineitem.quantity = this.qty || 1;

    return lineitem;
  };

  this.items = function () {
    var list = [];

    list.push(this.lineItem(ProductPage.poster, "poster"));

    list.push(this.lineItem(ProductPage.passepartout, "passepartout"));

    list.push(this.lineItem(ProductPage.frame, "frame"));

    return list.filter(function (item) {
      if (item) {
        return true;
      }
    });
  };
};

var Passepartout = function () {
  this.nodes = {
    product: document.querySelector('[data-section-id="product-template"]'),
    imageTarget: document.querySelector("[data-passepartout-image]"),
    module: document.querySelector(".passepartout-module"),
    json: document.querySelector("[data-passepartout-json]"),
    dropdown: document.querySelector(".passepartout-module .ProductForm__Option"),
  };

  this.activeProduct = ProductPage.passepartout.product;

  this.product_dump = JSON.parse(this.nodes.json.innerText);
  this.products = this.product_dump.passepartout;

  this.images = {
    loaded: false,
    load_list: [],
  };

  this.saveImages = function () {
    if (this.images.loaded) {
      return;
    }
    this.images.load_list = this.products.map(function (product) {
      var image = new Image();
      image.src = product.image;
      return image;
    });

    this.images.loaded = true;
  };

  this.setProductImage = function () {
    this.activeProduct = ProductPage.passepartout.product;
    if (this.activeProduct) {
      this.activeImgString = this.activeProduct.image ? "url(" + this.activeProduct.image + ")" : null;

      this.nodes.imageTarget.style.backgroundImage = this.activeImgString;
      this.nodes.product.setAttribute("data-gallery-has-passepartout", "");
      return;
    }

    this.nodes.product.removeAttribute("data-gallery-has-passepartout");
    this.nodes.imageTarget.style.backgroundImage = null;
  };

  this.updateOptionItems = function (poster_variant) {
    this.dropdownItems = document.querySelectorAll(".passepartout-module [data-is-passepartout]");
    var passepartoutSize = findPassepartoutSizeFromPrintsize(poster_variant.option1);

    this.dropdownItems.forEach(function (item) {
      var product_id = item.getAttribute("data-passepartout-id");
      var productObj = findPassepartoutProductById(product_id);

      var availableVariant = productObj.variants.find(function (variant) {
        if (convertedPassepartoutName(variant.title) == passepartoutSize) {
          return variant;
        }
      });

      var newLabel = passepartoutTranslations.placeholder;

      if (availableVariant) {
        newLabel =
          productObj.title.split("-")[1] + " - " + availableVariant.title + " + " + toMoney(availableVariant.price);
        item.innerHTML = newLabel;
        item.setAttribute("data-value", newLabel);
        item.removeAttribute("data-variantitem-unavailable");
      } else {
        item.setAttribute("data-variantitem-unavailable", "");
      }
    });
  };

  this.updateActiveProductAndVariant = function (poster_variant) {
    var passepartoutSize = findPassepartoutSizeFromPrintsize(poster_variant.option1);
    this.activeOptionItem = this.nodes.module.querySelector(".is-selected");
    this.dropdown = this.nodes.module.querySelector(".ProductForm__SelectedValue");

    this.optionLabel = passepartoutTranslations.placeholder;
    this.optionClear = document.querySelector('[data-passepartout-id="null"]');

    this.activeVariant = findVariantFromOptionList(".passepartout-module", passepartoutSize);

    if (this.activeOptionItem && this.activeVariant) {
      this.optionLabel = this.activeOptionItem.getAttribute("data-value");
    } else {
      if (this.activeOptionItem && !this.activeVariant) {
        this.optionClear.click();
      }
    }

    this.dropdown.innerHTML = this.optionLabel;
    this.activeVariant = false;

    // find active passepartout variant item
    if (!this.activeOptionItem) {
      ProductPage.passepartout = {};
    }

    var passepartoutSize = findPassepartoutSizeFromPrintsize(poster_variant.option1);

    if (this.activeOptionItem) {
      this.activeOptionId = this.activeOptionItem.getAttribute("data-passepartout-id");
      this.activeProduct = findPassepartoutProductById(this.activeOptionId);

      if (this.activeProduct) {
        this.activeVariant = this.activeProduct.variants.find(function (variant) {
          if (convertedPassepartoutName(variant.title) == passepartoutSize) {
            return variant;
          }
        });

        this.activeVariant ? (this.activeVariant.product = this.activeProduct) : "";
      }

      ProductPage.passepartout = this.activeVariant ? this.activeVariant : {};
    }
  };

  // Cache images on interaction
  // august 2022 update
  if (this.nodes.dropdown) {
    this.nodes.dropdown.addEventListener("click", this.saveImages.bind(this));
  }
};

var PassepartoutModule = new Passepartout();

// cache images when interacting with dropdown for passepartout
var passepartoutDropdown = document.querySelector(".passepartout-module .ProductForm__Option");
if (passepartoutDropdown) {
  ProductPage.line_items = new ProductPage.form_items(".ProductForm");

  var updateFrameImage = function () {
    var productpageGallery = document.querySelector('[data-section-id="product-template"]');
    var product = ProductPage.frame.product;
    var passepartout_image = document.querySelector("[data-frame-image]");

    passepartout_image.classList.remove("frame-module__image--visible");
    if (product) {
      var image = product.image;

      var backgroundImageSrc = image ? "url(" + image + ")" : null;

      passepartout_image.style.backgroundImage = backgroundImageSrc;

      passepartout_image.classList.add("frame-module__image--visible");
      return;
    }

    passepartout_image.style.backgroundImage = null;
  };

  var findActiveOptionFromList = function (list_selector) {
    if (!list_selector) {
      return;
    }

    var parent = document.querySelector(list_selector);

    if (!parent) {
      return false;
    }

    var passepartoutSelectItem = parent.querySelector(".ProductForm__SelectedValue");

    return parent.querySelector(".is-selected");
  };

  var findVariantFromOptionList = function (parent_selector, size) {
    var activeOption = findActiveOptionFromList(parent_selector);
    var productListToSearch = passePartoutProducts;
    var isPassepartout = true;

    if (!activeOption) {
      return;
    }

    var productId = activeOption.getAttribute("data-passepartout-id");

    if (!productId) {
      productId = activeOption.getAttribute("data-frame-id");
      productListToSearch = frameJsonProducts;
    }

    var passepartoutActiveProduct = productListToSearch.find(function (item) {
      if (item.id == productId) {
        return true;
      }
    });

    if (passepartoutActiveProduct) {
      var passepartoutVariant = passepartoutActiveProduct.variants.find(function (variant) {
        if (convertedPassepartoutName(variant.title) == size) {
          variant.product = passepartoutActiveProduct;
          return variant;
        }
      });
    }

    return passepartoutVariant;
  };

  document.addEventListener("variant:changed", function (event) {
    var poster_variant = event.detail.variant;
    var printVariant = poster_variant;
    var printSize = printVariant.option1;

    ProductPage.poster = poster_variant;

    PassepartoutModule.updateOptionItems(poster_variant);
    PassepartoutModule.updateActiveProductAndVariant(poster_variant);

    // Determine correct frame size, if we have a passepartout
    var frameSize = printSize;

    if (ProductPage.passepartout.id) {
      frameSize = findPassepartoutSizeFromPrintsize(printSize);
    }

    var frameVariant = findVariantFromOptionList(".frame-module", frameSize);
    ProductPage.frame = frameVariant;

    if (!frameVariant) {
      ProductPage.frame = {};
      ProductPage.frame.price = 0;
    }

    var priceButton = document.querySelector(".ProductForm__AddToCart [data-money-convertible]");
    var priceProductPage = document.querySelectorAll(".ProductMeta__Price[data-money-convertible]");

    priceButton.setAttribute("data-blur-btn", "");

    priceButton.innerHTML = ProductPage.pricing.totalMoney();

    priceProductPage.forEach(function (elem) {
      elem.innerHTML = ProductPage.pricing.totalMoney();
    });

    priceButton.removeAttribute("data-blur-btn");

    var allFrames = document.querySelectorAll(".frame-module [data-is-frame]");

    allFrames.forEach(function (item) {
      var product_id = item.getAttribute("data-frame-id");
      var productObj = findFrameProductById(product_id);

      var availableVariant = productObj.variants.find(function (variant) {
        if (convertedPassepartoutName(variant.title) == frameSize) {
          return variant;
        }
      });

      var newLabel = frameTranslations.placeholder;

      if (availableVariant) {
        newLabel =
          productObj.title.split("-").reverse()[0] +
          " + " +
          availableVariant.title +
          " + " +
          toMoney(availableVariant.price);
        item.innerHTML = newLabel;
        item.setAttribute("data-value", newLabel);
        item.removeAttribute("data-variantitem-unavailable");
      } else {
        item.setAttribute("data-variantitem-unavailable", "");
      }
    });

    var parentFrame = document.querySelector(".frame-module");
    var frameSelectItem = parentFrame.querySelector(".ProductForm__SelectedValue");
    var activeFrameDropdownItem = parentFrame.querySelector(".is-selected");

    var dropdownFrameMessage = frameTranslations.placeholder;

    if (activeFrameDropdownItem && frameVariant) {
      dropdownFrameMessage = activeFrameDropdownItem.getAttribute("data-value");
    } else {
      if (activeFrameDropdownItem) {
        var clearFrame = document.querySelector('[data-frame-id="null"]');
        clearFrame.click();
      }
    }

    frameSelectItem.innerHTML = dropdownFrameMessage;

    PassepartoutModule.setProductImage();

    updateFrameImage();
  });
}
